import { RFC4646Locale } from '@catawiki/locale';
export const SETTINGS = {
    [RFC4646Locale.ENGLISH]: {
        show_press_page: true,
        show_collectors_platform: true,
        show_category_guidelines: true,
    },
    [RFC4646Locale.DUTCH]: {
        show_press_page: true,
        show_collectors_platform: true,
        show_category_guidelines: true,
    },
    [RFC4646Locale.GERMAN]: {
        show_press_page: true,
        show_collectors_platform: true,
        show_category_guidelines: true,
    },
    [RFC4646Locale.FRENCH]: {
        show_press_page: true,
        show_collectors_platform: true,
        show_category_guidelines: true,
    },
    [RFC4646Locale.CHINESE_TRADITIONAL]: {
        show_press_page: true,
        show_collectors_platform: false,
        show_category_guidelines: false,
    },
    [RFC4646Locale.CHINESE_SIMPLIFIED]: {
        show_press_page: true,
        show_collectors_platform: false,
        show_category_guidelines: false,
    },
    [RFC4646Locale.ITALIAN]: {
        show_press_page: true,
        show_collectors_platform: false,
        show_category_guidelines: true,
    },
    [RFC4646Locale.SPANISH]: {
        show_press_page: true,
        show_collectors_platform: false,
        show_category_guidelines: true,
    },
    [RFC4646Locale.PORTUGUESE]: {
        show_press_page: true,
        show_collectors_platform: false,
        show_category_guidelines: true,
    },
    [RFC4646Locale.DANISH]: {
        show_press_page: true,
        show_collectors_platform: false,
        show_category_guidelines: false,
    },
    [RFC4646Locale.SWEDISH]: {
        show_press_page: true,
        show_collectors_platform: false,
        show_category_guidelines: false,
    },
    [RFC4646Locale.NORWEGIAN]: {
        show_press_page: false,
        show_collectors_platform: false,
        show_category_guidelines: false,
    },
    [RFC4646Locale.POLISH]: {
        show_press_page: true,
        show_collectors_platform: false,
        show_category_guidelines: false,
    },
    [RFC4646Locale.HUNGARIAN]: {
        show_press_page: true,
        show_collectors_platform: false,
        show_category_guidelines: false,
    },
    [RFC4646Locale.ROMANIAN]: {
        show_press_page: true,
        show_collectors_platform: false,
        show_category_guidelines: false,
    },
    [RFC4646Locale.GREEK]: {
        show_press_page: true,
        show_collectors_platform: false,
        show_category_guidelines: false,
    },
    [RFC4646Locale.FINNISH]: {
        show_press_page: true,
        show_collectors_platform: false,
        show_category_guidelines: false,
    },
};
//# sourceMappingURL=constants.js.map